module.exports = __webpack_public_path__ + "static/img/kouhao.c0714a2d.png";